<template>
  <div class="rec-products">
    <ul class="count-s">
      <li>
        <span style="color: #50BAEC;">{{ prodTotalInfo.productTotal || 0 }}个</span>
        <span>产品系列</span>
      </li>
      <li>
        <span style="color: #EEB63D;">{{ prodTotalInfo.companyTotal || 0 }}家</span>
        <span>供货厂家</span>
      </li>
      <li>
        <span style="color: #A4D24A;">{{ prodTotalInfo.hasModelTotal || 0 }}个</span>
        <span>模型系列</span>
      </li>
    </ul>

    <!-- 浏览更多 -->
    <router-link
      class="browse-more a-text-none"
      :to="OpenService.getSearchLibUrl(keywords)"
      :target="OpenService.getRouterTarget()"
    >
      <span>浏览更多</span>
      <i class="el-icon-d-arrow-right"></i>
    </router-link>

    <!-- 产品展示 -->
    <div class="prod-exhibition" :style="{ maxHeight: viewMaxHeight + 'px' }">
      <!-- 产品 -->
      <div
        class="prod a-text-none"
        v-for="(item, index) of prodList"
        :key="index"
        @click="openProdDetails(item.prodId)"
      >
        <div class="prod-image">
          <prod-icon
            :src="item.prodLogo"
            :width="59"
            :height="59"
          ></prod-icon>
        </div>
        <div class="prod-info">
          <p class="text-clamp1" :title="item.prodName">{{ item.prodName }}</p>
          <div class="desc text-clamp1">
            {{ item.compName }}
          </div>
          <div class="keywords text-clamp1">
            {{ item.keywords ? item.keywords.toString() : "" }}
          </div>
        </div>
      </div>
      <div class="prod-empty" v-for="item of 8" :key="`key_${item}`"></div>
    </div>

    <el-empty description="暂无数据" v-if="prodList.length <= 0 && !rightLoading"></el-empty>

  </div>
</template>

<script>
import { OpenService, TodaySearchService } from "@/service";

import ProdIcon from "@/components/icon/prod-icon.vue";

export default {
  props: {
    rightLoading: { default: false }
  },
  components: { ProdIcon },
  data() {
    return {
      keywords: '',
      prodList: [], // 选中关键词的关联产品
      prodTotalInfo: {}, // 选中关键词的信息
      OpenService,
      viewMaxHeight: 0,
    }
  },
  mounted() {
    this.setMaxHeight();
    window.addEventListener('resize',() => {
      this.setMaxHeight();
    },false);
  },
  methods: {
    openProdDetails(prodId) {
      OpenService.openProdDetails(prodId);
    },
    async setMaxHeight() {
      this.viewMaxHeight = window.document.body.clientHeight - 300;
    },
    // 推荐词查询产品
    async recommendProducts(keywords = '') {
      this.$emit('loadingChange', true);
      this.keywords = keywords;
      const res = await TodaySearchService.recommendProducts(
        keywords,
        42
      );
      if (res.code === 0) {
        let { list, ...rest } = res.data;
        this.prodList = list;
        this.prodTotalInfo = { ...rest };
      }
      this.$emit('loadingChange', false);
    },
  },
}
</script>

<style lang="less" scoped>
.browse-more{
  font-size: 14px;
  color: #0989C5;
  position: absolute;
  right: 20px;
  top: 10px;
}
.count-s{
  padding: 10px 0;
  display: flex;
  margin-bottom: 4px;
  li{
    margin-right: 18px;
    font-size: 14px;
    color: @main-color;
  }
  span:first-child{
    font-weight: bold;
  }
}
.rec-products{
  min-height: 200px;
  position: relative;
}
.prod-exhibition {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 90px;
  justify-content: space-between;
  overflow-y: auto;

  .prod {
    display: flex;
    min-width: 260px;
    max-width: 300px;
    margin-bottom: 11px;
    margin-right: 10px;
    overflow: hidden;
    flex: 1;
    cursor: pointer;
  }
  .prod-empty{
    min-width: 260px;
    max-width: 300px;
    margin-bottom: 11px;
    margin-right: 10px;
    overflow: hidden;
    flex: 1;
  }

  .prod-image {
    width: 60px;
    height: 60px;
    border: 1px solid #D6D6D6;
    margin-right: 10px;
    img{
      width: 58px;
      height: 58px;
    }
  }
}
.prod-info {
  width: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 14px;
    line-height: 24px;
    color: #2F3748;
    margin: 0;
  }

  .desc {
    font-size: 12px;
    color: @text-color-call-out;
    margin: 6px 0;
  }

  .keywords {
    font-size: 12px;
    color: #b9b9b9;
  }
}
</style>
